import { render } from "./ProductsView.vue?vue&type=template&id=b7acb326"
import script from "./ProductsView.vue?vue&type=script&lang=js"
export * from "./ProductsView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__